// All brands share the same poster filenames, including P99.
export const RESULT_FILENAMES = {
    MC: { DAY: "MC-Day.jpg", NIGHT: "MC-Night.jpg" },
    KP: { DAY: "KP-Day-MT.jpg", NIGHT: "KP-Night-MT.jpg" },
    KP_MC: { DAY: "KP-Day-MC.jpg", NIGHT: "KP-Night-MC.jpg" },
    MT: { DAY: "MT-Day.jpg", NIGHT: "MT-Night.jpg" },
    TC: { DAY: "TC-Day.jpg", NIGHT: "TC-Night.jpg" },
    KH: "KH.jpg",
    SC: "SC.jpg",
    LEAP: "MHSB.jpg",
    DEFAULT: { DAY: "MC-Day.jpg", NIGHT: "MC-Night.jpg" },
};

const RESULT_ASSET_ROOT = "https://vnonemedia.s3.ap-southeast-1.amazonaws.com/lottery-live-poster";

// Preserve the default-background export used by result layout configuration.
export const RESULT_BACKGROUNDS = Object.fromEntries(
    Object.entries(RESULT_FILENAMES).map(([type, entry]) => [
        type,
        typeof entry === "string"
            ? `${RESULT_ASSET_ROOT}/p99/${entry}`
            : Object.fromEntries(Object.entries(entry).map(([mode, filename]) => [
                mode, `${RESULT_ASSET_ROOT}/p99/${filename}`,
            ])),
    ])
);

export function normalizeResultBrand(brand = "p99") {
    return String(brand).toLowerCase();
}

// Accept any brand folder name without allowing URL or path separators.
export function isValidResultBrand(brand) {
    return /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/.test(normalizeResultBrand(brand));
}

export function getBrandResultBackground(lotteryType, mode, brand = "p99") {
    const normalizedBrand = normalizeResultBrand(brand);
    if (!isValidResultBrand(normalizedBrand)) {
        throw new Error(`Invalid result brand: ${brand}`);
    }
    const type = String(lotteryType || "").toUpperCase();
    const entry = RESULT_FILENAMES[type] || RESULT_FILENAMES.DEFAULT;
    const image = entry[mode] || entry;
    return `${RESULT_ASSET_ROOT}/${normalizedBrand}/${image}`;
}

export const RESULT_RATIOS = {
    MC: { DAY: "467 / 721", NIGHT: "467 / 721" },
    MT: { DAY: "467 / 721", NIGHT: "467 / 721" },
    TC: { DAY: "467 / 721", NIGHT: "467 / 721" },
    KP: { DAY: "1074 / 1530", NIGHT: "971 / 1500" },
    KH: "702 / 878",
    SC: "702 / 960",
    LEAP: "702 / 960",
    DEFAULT: { DAY: "467 / 721", NIGHT: "467 / 721" },
};
